import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import MsalProvider from './components/Auth/MsalProvider';
import { initializeDatadog } from './datadog';
import { PublicClientApplication } from '@azure/msal-browser'; // Import the type
import ErrorBoundary from './components/GlobalErrorHandler';

initializeDatadog();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const Index = () => {
  // Set the type to PublicClientApplication or null
  const [msalInstance, setMsalInstance] = useState<PublicClientApplication | null>(null);

  return (
    <MsalProvider onMsalReady={setMsalInstance}>
      {' '}
      {/* Pass setMsalInstance here */}
      {msalInstance && (
        <Router>
          <ErrorBoundary>
            <App pca={msalInstance} /> {/* Pass msalInstance to App */}
          </ErrorBoundary>
        </Router>
      )}
    </MsalProvider>
  );
};

root.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>,
);
